import { render } from "./App.vue?vue&type=template&id=cf80cf12"
const script = {}

import exportComponent from "/Users/gray/Desktop/Work_temp/經貿網/web/project/rotate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__